module.exports = __webpack_public_path__ + "static/HKGrotesk-Light-539752d0f380e54b59a8f6c5e9a7d988.woff";